// src/reducers/searchSlice.js
import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
    name: 'search',
    initialState: {
        userData: '', 
    },
    reducers: {
        setUserData: (state, action) => {
            state.userData = action.payload;
        },
        resetUserData: (state) => {
            state.userData = '';
        },
    },
});



export const { setUserData } = userSlice.actions;
export default userSlice.reducer;

